import { createAction } from 'redux-actions';
import { createDeferredAction } from '../../utils/redux';
import { PARKING_METER_MODULE } from '../../configs/moduleNames';
import {
  BEGIN, FAILED, HIDE, SHOW, SUCCESSFUL,
} from '../../configs/actionNames';

export const LOAD_HOST_LIST = '_LOAD_HOST_LIST';
export const LOAD_HOST_COMPONENTS = '_LOAD_HOST_COMPONENTS';
export const HISTORY_POPUP = '_HISTORY_POPUP';
export const LOAD_HISTORY_LIST = '_LOAD_HISTORY_LIST';
export const HOST_COMMAND_DISPATCH = '_HOST_COMMAND_DISPATCH';
export const HOST_COMMAND_CANCEL = '_HOST_COMMAND_CANCEL';
export const LOAD_HOST_STATUSES_LIST = '_LOAD_HOST_STATUSES_LIST';
export const LOAD_HOST_DETAIL = '_LOAD_HOST_DETAIL';
export const HISTORY_EXPORT_WORD = '_HISTORY_EXPORT_WORD';
export const LOAD_HOST_STATUSES_HISTORY = '_LOAD_HOST_STATUSES_HISTORY';
export const LOAD_ZONES = '_LOAD_ZONES';
export const SET_SERVER_TIME_ZONE = '_SET_SERVER_TIME_ZONE';
export const HOST_PROBLEMS_DETAIL = '_HOST_PROBLEMS_DETAIL';
export const LOAD_HOST_PROBLEMS = '_LOAD_HOST_PROBLEMS';

export const loadHostList = createDeferredAction(PARKING_METER_MODULE + LOAD_HOST_LIST);
export const loadHostListBegin = createAction(PARKING_METER_MODULE + LOAD_HOST_LIST + BEGIN);
export const loadHostListSuccessful = createAction(PARKING_METER_MODULE + LOAD_HOST_LIST + SUCCESSFUL);
export const loadHostListFailed = createAction(PARKING_METER_MODULE + LOAD_HOST_LIST + FAILED);

export const loadHostComponents = createDeferredAction(PARKING_METER_MODULE + LOAD_HOST_COMPONENTS);
export const loadHostComponentsSuccessful = createAction(PARKING_METER_MODULE + LOAD_HOST_COMPONENTS + SUCCESSFUL);
export const loadHostComponentsFailed = createAction(PARKING_METER_MODULE + LOAD_HOST_COMPONENTS + FAILED);

export const showHistoryPopup = createAction(PARKING_METER_MODULE + HISTORY_POPUP + SHOW);
export const hideHistoryPopup = createAction(PARKING_METER_MODULE + HISTORY_POPUP + HIDE);

export const loadHistoryList = createDeferredAction(PARKING_METER_MODULE + LOAD_HISTORY_LIST);
export const loadHistoryListSuccessful = createAction(PARKING_METER_MODULE + LOAD_HISTORY_LIST + SUCCESSFUL);
export const loadHistoryListFailed = createAction(PARKING_METER_MODULE + LOAD_HISTORY_LIST + FAILED);

export const hostCommandDispatch = createDeferredAction(PARKING_METER_MODULE + HOST_COMMAND_DISPATCH);
export const hostCommandDispatchSuccessful = createAction(PARKING_METER_MODULE + HOST_COMMAND_DISPATCH + SUCCESSFUL);
export const hostCommandDispatchFailed = createAction(PARKING_METER_MODULE + HOST_COMMAND_DISPATCH + FAILED);

export const hostCommandCancel = createDeferredAction(PARKING_METER_MODULE + HOST_COMMAND_CANCEL);
export const hostCommandCancelSuccessful = createAction(PARKING_METER_MODULE + HOST_COMMAND_CANCEL + SUCCESSFUL);
export const hostCommandCancelFailed = createAction(PARKING_METER_MODULE + HOST_COMMAND_CANCEL + FAILED);

export const loadHostStatusesList = createDeferredAction(PARKING_METER_MODULE + LOAD_HOST_STATUSES_LIST);
export const loadHostStatusesListBegin = createAction(PARKING_METER_MODULE + LOAD_HOST_STATUSES_LIST + BEGIN);
export const loadHostStatusesListSuccessful = createAction(PARKING_METER_MODULE + LOAD_HOST_STATUSES_LIST + SUCCESSFUL);
export const loadHostStatusesListFailed = createAction(PARKING_METER_MODULE + LOAD_HOST_STATUSES_LIST + FAILED);

export const loadHostDetail = createDeferredAction(PARKING_METER_MODULE + LOAD_HOST_DETAIL);
export const loadHostDetailSuccessful = createAction(PARKING_METER_MODULE + LOAD_HOST_DETAIL + SUCCESSFUL);
export const loadHostDetailFailed = createAction(PARKING_METER_MODULE + LOAD_HOST_DETAIL + FAILED);

export const historyExportWord = createDeferredAction(PARKING_METER_MODULE + HISTORY_EXPORT_WORD);
export const historyExportWordSuccessful = createAction(PARKING_METER_MODULE + HISTORY_EXPORT_WORD + SUCCESSFUL);
export const historyExportWordFailed = createAction(PARKING_METER_MODULE + HISTORY_EXPORT_WORD + FAILED);

export const hostProblemsDetail = createDeferredAction(PARKING_METER_MODULE + HOST_PROBLEMS_DETAIL);
export const hostProblemsDetailSuccessful = createAction(PARKING_METER_MODULE + HOST_PROBLEMS_DETAIL + SUCCESSFUL);
export const hostProblemsDetailFailed = createAction(PARKING_METER_MODULE + HOST_PROBLEMS_DETAIL + FAILED);

export const loadHostStatusesHistory = createDeferredAction(PARKING_METER_MODULE + LOAD_HOST_STATUSES_HISTORY);
export const loadHostStatusesHistoryBegin = createAction(PARKING_METER_MODULE + LOAD_HOST_STATUSES_HISTORY + BEGIN);
export const loadHostStatusesHistorySuccessful = createAction(PARKING_METER_MODULE + LOAD_HOST_STATUSES_HISTORY + SUCCESSFUL);
export const loadHostStatusesHistoryFailed = createAction(PARKING_METER_MODULE + LOAD_HOST_STATUSES_HISTORY + FAILED);

export const loadZones = createDeferredAction(PARKING_METER_MODULE + LOAD_ZONES);
export const loadZonesSuccessful = createAction(PARKING_METER_MODULE + LOAD_ZONES + SUCCESSFUL);
export const loadZonesFailed = createAction(PARKING_METER_MODULE + LOAD_ZONES + FAILED);

export const setServerTimeZone = createDeferredAction(PARKING_METER_MODULE + SET_SERVER_TIME_ZONE);
export const setServerTimeZoneSuccessful = createAction(PARKING_METER_MODULE + SET_SERVER_TIME_ZONE + SUCCESSFUL);
export const setServerTimeZoneFailed = createAction(PARKING_METER_MODULE + SET_SERVER_TIME_ZONE + FAILED);

export const loadHostProblems = createDeferredAction(PARKING_METER_MODULE + LOAD_HOST_PROBLEMS);
export const loadHostProblemsSuccessful = createAction(PARKING_METER_MODULE + LOAD_HOST_PROBLEMS + SUCCESSFUL);
export const loadHostProblemsFailed = createAction(PARKING_METER_MODULE + LOAD_HOST_PROBLEMS + FAILED);
